<template>
    <div>
        <!-- 日查看 -->
        <!-- <div class="info_list" v-show="day_obj.day_check">
            <div class="info_item">
                <div class="info_disp">
                    <div class="info_title">用电{{day_obj.degrees}}度</div>
                    <div class="info_text">剩余</div>
                </div>
                <div class="info_disp marTop5">
                    <div class="info_time">{{day_obj.useTime}}</div>
                    <div class="info_num">{{day_obj.endDegrees}}度</div>
                </div>
            </div>
        </div> -->
        <!-- 月查看 -->
        <!-- <div class="info_list" v-show="month_obj.month_check">
            <div class="info_item">
                <div class="info_disp">
                    <div class="info_title">用电{{month_obj.month_amount}}度</div>
                </div>
                <div class="info_disp marTop5">
                    <div class="info_time">{{month_obj.month_time}}</div>
                </div>
            </div>
        </div> -->
        <div v-if="list.length > 0">
            <div class="item_power" v-for="(item,index) in list" :key="index">
                <div class="item_head">
                    <div class="item_name">名称：{{item.shop_name}}</div>
                    <div class="item_remark">{{item.remark}}</div>
                </div>
                <div class="item_balance">用量：<span>{{item.total_consump}}</span>度</div>
                <div class="item_info">时间：{{item.start_reading_time}} - {{item.end_reading_time}}</div>
            </div>
        </div>
        <!-- 无记录 -->
        <div class="text_description" v-show="notText">{{text}}</div>
    </div>
</template>

<script>
export default {
    props:['text','notText','list']
}
</script>

<style scoped>
.info_list {
    margin-top: 0.1rem;
}
.info_item {
    padding: 0 0.1rem;
    height: 0.7rem;
    border-bottom: 1px solid #ccc;
    background: #fff;
    display: flex;
    flex-wrap: wrap;
    align-content: center;
}
.info_disp {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    width: 100%;
}
.marTop5 {
    margin-top: 0.05rem;
}
.info_title {
    font-size: 0.19rem;
    color: #3e5f8a;
}
.info_time {
    font-size: 0.12rem;
    color: #828282;
}
.info_text {
    font-size: 0.12rem;
    color: #828282;
}
.info_num {
    font-size: 0.14rem;
    color: #828282;
}
.text_description {
    text-align: center;
    margin-top: 1rem;
    font-size: 0.14rem;
    color: #828282;
}



.item_power {
    background-color: #fff;
    padding: 0.1rem;
    box-shadow: 0 0 0.1rem 0 #ccc inset;
}
.item_head {
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.item_name {
    font-size: 0.16rem;
    color: #000;
    font-weight: bold;
}
.item_remark {
    font-size: 0.14rem;
    color: #232323;
    line-height: 0.3rem;
}
.item_balance {
    font-size: 0.14rem;
    color: #232323;
    line-height: 0.3rem;
}
.item_balance span {
    font-size: 0.14rem;
    color: #fa0606;
}
.item_info {
    font-size: 0.14rem;
    color: rgb(196, 196, 196);
    line-height: 0.3rem;
}
.item_info span {
    font-size: 0.14rem;
    color: #fa0606;
}
</style>